import { EMPLOYMENT_ROLE_ENUM } from "@/models/IEmployer";

export const mapToggleValueToEmploymentRole = (value: boolean | number): EMPLOYMENT_ROLE_ENUM => {
    return !!value ? EMPLOYMENT_ROLE_ENUM.EMPLOYER : EMPLOYMENT_ROLE_ENUM.EMPLOYEE;
}

export const EMPLOYMENT_ROLE_BOOL: { [key: number]: EMPLOYMENT_ROLE_ENUM } = {
    1: EMPLOYMENT_ROLE_ENUM.EMPLOYER,
    0: EMPLOYMENT_ROLE_ENUM.EMPLOYEE
};